import { render } from "./CXCompetitorSettings.vue?vue&type=template&id=9b85cbf8&scoped=true"
import script from "./CXCompetitorSettings.vue?vue&type=script&lang=js"
export * from "./CXCompetitorSettings.vue?vue&type=script&lang=js"

import "./CXCompetitorSettings.vue?vue&type=style&index=0&id=9b85cbf8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b85cbf8"]])

export default __exports__